import { StatChartResultResponse } from '@business/entities/dashboard';
import { Formatter } from '@core/utils/formatter';
import React, { memo, useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import CountUp from 'react-countup';
import { Card } from 'reactstrap';
import { WidgetProps } from '../types';
import { WidgetIcons } from '../BaseWidget';
import { R } from '@core/utils/r';
import { StatWithChartWidgetConfigData } from './StatWithChartWidgetConfig';

export const StatWithChartWidget = memo((props: WidgetProps<StatChartResultResponse, StatWithChartWidgetConfigData>) => {
  const { settings, result, config } = props;
  const colors = useMemo(() => {
    const color = R.get(config, 'color');
    if (color) return [color];
    return ['#f1b44c'];
  }, [config]);

  const isPositiveChange = useMemo(() => result?.color === 'success', [result]);

  return (
    <Card className="p-4" style={{ marginBottom: 0, flex: 1 }}>
      <div className="d-flex flex-direction-column">
        <div className="mr-2" style={{ minWidth: 150 }}>
          <div className="text-muted d-flex flex-row align-items-center" style={{ marginBottom: '0.5rem' }}>
            {settings.title || 'Stat with Chart'}
            <WidgetIcons {...props} />
          </div>

          <div>
            <h5>
              <CountUp
                separator=","
                preserveValue
                end={result?.value || 0}
                duration={1}
                decimals={result?.decimal || 0}
                prefix={result?.label || ''}
              ></CountUp>
            </h5>
            <p className="text-muted text-truncate mb-0">
              {result?.label ? Formatter.formatCurrency(result?.change || 0.0) : Formatter.formatInteger(result?.change || 0.0)}
              {'% '}
              <i className={`mdi mdi-arrow-${isPositiveChange ? 'up' : 'down'} ml-1 text-${isPositiveChange ? 'success' : 'danger'}`} />
            </p>
          </div>
        </div>

        <div style={{ flex: 1 }}>
          <div className="apex-charts">
            <ReactApexChart
              options={{
                chart: { sparkline: { enabled: !0 } },
                stroke: { curve: 'smooth', width: 2 },
                colors,
                fill: {
                  type: 'gradient',
                  gradient: {
                    shadeIntensity: 1,
                    inverseColors: !1,
                    opacityFrom: 0.45,
                    opacityTo: 0.05,
                    stops: [25, 100, 100, 100],
                  },
                },
                tooltip: {
                  fixed: {
                    enabled: !1,
                  },
                  y: {
                    formatter: (value: number) => (result?.label ? Formatter.formatCurrency(value) : Formatter.formatInteger(value)),
                  },
                  x: {
                    format: 'dd MMM yyyy',
                  },
                  marker: { show: !1 },
                },
                xaxis: {
                  type: 'datetime',
                },
              }}
              series={
                result
                  ? result?.series
                  : [
                      {
                        data: [
                          [1327359600000, 30.95],
                          [1327446000000, 31.34],
                          [1327532400000, 31.18],
                          [1327618800000, 31.05],
                          [1327878000000, 31.0],
                          [1327964400000, 30.95],
                          [1328050800000, 31.24],
                          [1328137200000, 31.29],
                          [1328223600000, 31.85],
                          [1328482800000, 31.86],
                          [1328569200000, 32.28],
                          [1328655600000, 32.1],
                          [1328742000000, 32.65],
                          [1328828400000, 32.21],
                          [1329087600000, 32.35],
                        ],
                      },
                    ]
              }
              type="area"
              height={40}
            />{' '}
          </div>
        </div>
      </div>
    </Card>
  );
});
